// @flow

export const isMobileScreen = () => typeof document !== 'undefined' && (document.documentElement?.clientWidth || 0) <= 812;
